/**
 * @file   Source/gitcha_Web/src/helpers/common.js
 * @brief  This file is responsible for defing common functions used acroos the application
 * @date   April, 2023
 * @author ZCO Engineer
 * @copyright (c) 2023, ZCO
 */
import {
  BUY,
  DATE_FORMAT_MM_DD_YYYY,
  DEFAULT_MAP_ZOOM,
  DISPLAT_STR,
  DISPLAY_BUY,
  DISPLAY_LTR,
  DISPLAY_LTR_TIMELINE,
  DISPLAY_STR_PPTY_TYPE,
  DISPLAY_TEXT_BUY,
  DISPLAY_TEXT_LTR,
  DISPLAY_TEXT_STR,
  INTRODUCTION_EXPIRATION_TIME,
  INVENTORY_KEY,
  INVENTORY_PURPOSE,
  INVESTOR_MEMBER_PLAN,
  IS_APARTMENT_CONDO,
  IS_HOUSE,
  IS_LAND,
  IS_MANUFACTURE,
  IS_TOWNHOME,
  LONG_RENT,
  LOT_LAND,
  SCROLL_DIRECTION_DOWN,
  SHORT_RENT,
  USER_INFO_KEY,
  USER_TYPE_AGENT,
  WANT_AD_KEY,
} from "../../constants/common";
import TimelineIcon from "../../images/timeline-icon.svg";
import BuyerAgreementTick from "../../images/v2/BuyerAgreementTick.svg";
import { convertToNumber } from "../validations";
import VisaIcon from "../../images/visa-icon-sm.svg";
import MasterIcon from "../../images/mastercard-icon.svg";
import AmexIcon from "../../images/american-exp-icon.svg";
import noImage from "../../images/no-image-placeholder.png";
import IntroductionVisaIcon from "../../images/pm-visa-icon.svg";
import IntroductionMasterIcon from "../../images/pm-mastercard-icon.svg";
import {
  getBuyerListUniqueFolderName,
  getGeoLocation,
  getMapStaticImage,
  getS3FolderName,
} from "../../services/commonServices";
import { getPreSignedUrls } from "../../services/fileUploadService";
import { getLotSizeList } from "../../services/wantAdService";
import { EXACT_MOVE_DATE_TYPE } from "../../constants/createWantAd";
import Resizer from "react-image-file-resizer";
import SchoolSmallIcon from "../../images/school-icon.svg";
import NeighborhoodIcon from "../../images/neighborhood-icon.svg";
import base64 from "base-64";
import utf8 from "utf8";
import { useLocation } from "react-router-dom";
import { format, parse, isValid } from "date-fns";
import moment from "moment";

export const loggedInUser = () => {
  const user = getLocalStorage(USER_INFO_KEY);
  return user;
};

export const convertToCurrencySystem = (amount) => {
  // Nine Zeroes for Billions
  return Math.abs(convertToNumber(amount)) >= 1.0e9
    ? (Math.abs(convertToNumber(amount)) / 1.0e9).toFixed(2) * 1 + "B"
    : // Six Zeroes for Millions
      Math.abs(convertToNumber(amount)) >= 1.0e6
      ? (Math.abs(convertToNumber(amount)) / 1.0e6).toFixed(2) * 1 + "M"
      : // Three Zeroes for Thousands
        Math.abs(convertToNumber(amount)) >= 1.0e3
        ? (Math.abs(convertToNumber(amount)) / 1.0e3).toFixed(2) * 1 + "k"
        : Math.abs(convertToNumber(amount));
};

/**
 * function to add thousand seperator comma
 */
export const thousandSeperatedValue = (value) => {
  if (value) {
    value = value.toString().replace(/[A-Za-z!@#$%^&*()]/g, "");
    let newValue = value.replace(/,/g, "");
    return newValue.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }
  return null;
};
// Thousand Seperator Comma without cents
export const thousandSeparatedValueWithoutCents = (value) => {
  if (value) {
    value = value.toString().replace(/[A-Za-z!@#$%^&*()]/g, "");
    let integerValue = value.split(".")[0];
    let formattedValue = integerValue
      .replace(/,/g, "")
      .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return formattedValue;
  }
  return null;
};

// Function to validate the Number of digit in Max-Min Budget
export const validateMaxDigit = (value, maxDigit) => {
  if (value.replace(/,/g, "").length > maxDigit) {
    return false;
  } else {
    return true;
  }
};
export const thousandSeperatedValueFilter = (value) => {
  if (value) {
    value = value.toString().replace(/[A-Za-z!@#$%^&*()]/g, "");
    let newValue = value.replace(/,/g, "");
    return newValue.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }
  return value;
};

export const checkIsNumber = (value) => {
  const numberReExp = /^[0-9\b]+$/;
  if (value) {
    const isValid = numberReExp.test(value);
    if (isValid) {
      return true;
    } else {
      return false;
    }
  }
  return true;
};

export const checkIsNumberWithDecimal = (value) => {
  const regExp = /^\d*\.?\d*$/;
  if (value) {
    const isValid = regExp.test(value);
    if (isValid) {
      return true;
    } else {
      return false;
    }
  }
  return true;
};

export const getStatePropertyValue = (property) => {
  const stateObject = getLocalStorage(WANT_AD_KEY);
  return _.get(stateObject, property, "");
};

export const getStateValue = (key, property) => {
  const stateObject = getLocalStorage(key);
  return _.get(stateObject, property, "");
};

const nth = function (d) {
  if (d > 3 && d < 21) return "th";
  switch (d % 10) {
    case 1:
      return "st";
    case 2:
      return "nd";
    case 3:
      return "rd";
    default:
      return "th";
  }
};

const dateFns_FormatDate = (dte) => {
  //  dte - 2023-12-13 11:54:22
  const parsedDate = parse(dte, "yyyy-MM-dd HH:mm:ss", new Date());
  if (!isValid(parsedDate)) {
    console.log(" Invalid Date : ", dte);
    return "Invalid Date";
  }
  return format(parsedDate, "MM/dd/yy");
};

export const formateDate = (dte, format) => {
  if (format) {
    const dateToFormat = dte && new Date(dte);
    const dateObj = new Date(dte);
    const date = dateObj.getDate();
    const month = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "June",
      "July",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ][dateObj.getMonth()];
    switch (format) {
      case "mm/dd/yyyy":
        return [
          ("0" + (dateToFormat?.getMonth() + 1)).slice(-2),
          ("0" + dateToFormat?.getDate()).slice(-2),
          dateToFormat?.getFullYear(),
        ].join("/");
      case "mm/dd":
        return [
          ("0" + (dateToFormat.getMonth() + 1)).slice(-2),
          ("0" + dateToFormat.getDate()).slice(-2),
        ].join("/");

      case "shortMonth":
        const year = dateObj.getFullYear();
        var dateString = month + " " + date + nth(date) + ", " + year;
        return dateString;

      case "shortMonthWithDateOnly":
        var dateString = month + " " + date + nth(date);
        return dateString;

      case "mm/dd/yy": {
        return dateFns_FormatDate(dte);
      }
    }
  } else {
    const dateObj = new Date(dte);
    const date = dateObj.getDate();
    const month = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ][dateObj.getMonth()];
    const year = dateObj.getFullYear();
    var dateString = month + " " + date + nth(date);
    return dateString;
  }
};

export const monthNameForFlexibleDate = (id) => {
  const itemArray = [
    { month: "Jan", id: 1 },
    { month: "Feb", id: 2 },
    { month: "March", id: 3 },
    { month: "April", id: 4 },
    { month: "May", id: 5 },
    { month: "June", id: 6 },
    { month: "July", id: 7 },
    { month: "Aug", id: 8 },
    { month: "Sept", id: 9 },
    { month: "Oct", id: 10 },
    { month: "Nov", id: 11 },
    { month: "Dec", id: 12 },
  ];

  if (id) {
    const filteredArray = itemArray.filter((a) => a.id == id);
    if (filteredArray) {
      return _.get(filteredArray[0], "month", "");
    }
  } else {
    return itemArray;
  }
};

export const durationForFlexibleDate = (id) => {
  const itemArray = [
    { duration: "Day", id: 1 },
    { duration: "Weekend", id: 2 },
    { duration: "Week", id: 3 },
    { duration: "Month", id: 4 },
  ];

  if (id) {
    const filteredArray = itemArray.filter((a) => a.id == id);
    if (filteredArray) {
      return _.get(filteredArray[0], "duration", "");
    }
  } else {
    return itemArray;
  }
};

export const durationForFlexibleDateResponsive = (id) => {
  const itemArray = [
    { duration: "Day", id: 1 },
    { duration: "Weekend", id: 2 },
    { duration: "Week", id: 3 },
    { duration: "Month", id: 4 },
  ];

  if (id) {
    const filteredArray = itemArray.filter((a) => a.id == id);
    if (filteredArray) {
      return _.get(filteredArray[0], "duration", "");
    }
  } else {
    return "";
  }
};

export const monthNameForFlexibleDateResponsive = (id) => {
  const itemArray = [
    { month: "Jan", id: 1 },
    { month: "Feb", id: 2 },
    { month: "March", id: 3 },
    { month: "April", id: 4 },
    { month: "May", id: 5 },
    { month: "June", id: 6 },
    { month: "July", id: 7 },
    { month: "Aug", id: 8 },
    { month: "Sept", id: 9 },
    { month: "Oct", id: 10 },
    { month: "Nov", id: 11 },
    { month: "Dec", id: 12 },
  ];

  if (id) {
    const filteredArray = itemArray.filter((a) => a.id == id);
    if (filteredArray) {
      return _.get(filteredArray[0], "month", "");
    }
  } else {
    return "";
  }
};

export const loadPreferredLocationHtml = (formValues, isMobileView) => {
  const highSchool = _.get(formValues, "highSchool", null);
  const neighborHood = _.get(formValues, "neighborHood", null);

  return (
    <>
      {highSchool && (
        <li>
          <span
            className={isMobileView ? "list-icn-wrap-mob" : "list-icn-wrap"}
          >
            <img src={SchoolSmallIcon} />
          </span>
          {isMobileView ? "Preferred School: " + highSchool : highSchool}
        </li>
      )}

      {neighborHood && (
        <li>
          <span
            className={isMobileView ? "list-icn-wrap-mob" : "list-icn-wrap"}
          >
            <img src={NeighborhoodIcon} />
          </span>
          {isMobileView
            ? "Preferred Neighborhood: " + neighborHood
            : neighborHood}
        </li>
      )}
    </>
  );
};

export const loadTimeLineHtml = (
  adType,
  adTypeBasedOnProperty,
  formValues,
  isMobileView,
) => {
  let timeLine;
  if (adType === BUY) {
    timeLine = _.get(formValues, "tlText", "");
  } else if (adType === LONG_RENT) {
    const moveInTimeLine = convertToNumber(
      _.get(formValues, "moveInTimeLine", ""),
    );
    const moveInDate = _.get(formValues, "startDate", "");
    if (moveInTimeLine === EXACT_MOVE_DATE_TYPE && moveInDate) {
      timeLine =
        "Move-in by " + formateDate(moveInDate, "shortMonthWithDateOnly");
    } else {
      timeLine = `${_.get(formValues, "moveInTxt", "")}`;
    }
  } else if (adType === SHORT_RENT && adTypeBasedOnProperty === LOT_LAND) {
    if (
      _.get(formValues, "startDate", "") &&
      _.get(formValues, "endDate", "")
    ) {
      timeLine =
        formateDate(_.get(formValues, "startDate", ""), "mm/dd/yyyy") +
        " - " +
        formateDate(_.get(formValues, "endDate", ""), "mm/dd/yyyy");
    } else {
      timeLine =
        durationForFlexibleDate(_.get(formValues, "duration", "")) +
        " - " +
        monthNameForFlexibleDate(_.get(formValues, "month", ""));
    }
  }
  if(!timeLine || timeLine === 'null') return "";

  if (
    (adType === SHORT_RENT && adTypeBasedOnProperty === LOT_LAND) ||
    adType !== SHORT_RENT
  ) {
    return (
      <li>
        <span className={isMobileView ? "list-icn-wrap-mob" : "list-icn-wrap"}>
          <img src={TimelineIcon} alt={TimelineIcon} />
        </span>
        <span className="timeline-value">Timeline: {timeLine}</span>
      </li>
    );
  } else {
    return "";
  }
};
export const loadBuyerAgreementHtml = (formValues) => {
  const isBuyerAgreementSigned = _.get(formValues, "buyersAgreementSigned");
  if (isBuyerAgreementSigned) {
    return (
      <li className="my-0">
        <span className={"list-icn-wrap"}>
          <img src={BuyerAgreementTick} alt={TimelineIcon} />
        </span>
        <span className="timeline-value">Buyer Agreement Signed</span>
      </li>
    );
  } else {
    return "";
  }
};
export const loadTimeLineString = (adType, formValues) => {
  let timeLine = "";
  if (adType === BUY) {
    timeLine = _.get(formValues, "tlText", "");
  } else if (adType === LONG_RENT) {
    const moveInTimeLine = convertToNumber(
      _.get(formValues, "moveInTimeLine", ""),
    );
    const moveInDate = _.get(formValues, "startDate", "");
    if (moveInTimeLine === EXACT_MOVE_DATE_TYPE && moveInDate) {
      timeLine =
        "Move-in by " + formateDate(moveInDate, "shortMonthWithDateOnly");
    } else {
      timeLine = `${_.get(formValues, "moveInTxt", "")}`;
    }
  } else if (adType === SHORT_RENT) {
    if (
      _.get(formValues, "startDate", null) &&
      _.get(formValues, "endDate", null)
    ) {
      timeLine =
        formateDate(_.get(formValues, "startDate", ""), "mm/dd/yyyy") +
        " - " +
        formateDate(_.get(formValues, "endDate", ""), "mm/dd/yyyy");
    } else if (
      _.get(formValues, "duration", null) &&
      _.get(formValues, "month", null)
    ) {
      timeLine =
        durationForFlexibleDateResponsive(_.get(formValues, "duration", "")) +
        " in " +
        monthNameForFlexibleDateResponsive(_.get(formValues, "month", ""));
    } else {
      timeLine = "";
    }
  }
  return timeLine;
};

export const capitalizeFirstString = (str) => {
  return str && str.charAt(0).toUpperCase() + str.slice(1);
};

export const upperCaseEachSentenceFirst = (input, lowercaseBefore) => {
  input = input === undefined || input === null ? "" : input;
  if (lowercaseBefore) {
    input = input.toLowerCase();
  }
  return input
    .toString()
    .replace(/(^|\. *)([a-z])/g, function (match, separator, char) {
      return separator + char.toUpperCase();
    });
};

export const replaceString = (str, replacingChar, charToBeReplcing) => {
  if (charToBeReplcing) {
    return str && str.replace(replacingChar, charToBeReplcing);
  } else {
    return str && str.replace(replacingChar, "");
  }
};

export const replaceComma = (str) => {
  const inputString = str && str.toString().replace(/,/g, "");
  if (!isNaN(inputString)) {
    return inputString;
  } else {
    const matchedString = inputString.match(/\d+/);
    return matchedString ? matchedString[0] : "";
  }
};

export function truncate(string, n) {
  return string?.length > n ? string.slice(0, n - 1) + "..." : string;
}

export function isIphone() {
  return /iPad|iPhone|iPod/.test(navigator.userAgent);
}

export const getAgentStateValue = (property) => {
  const stateObject = JSON.parse(localStorage.getItem("agentWantAdData"));
  return _.get(stateObject, property, "");
};

export const getLocalStorage = (key) => {
  if (key) {
    return JSON.parse(localStorage.getItem(key));
  } else {
    return {};
  }
};

export const setLocalStorage = (key, value) => {
  if (value) {
    localStorage.setItem(key, JSON.stringify(value));
  }
};

export const removeLocalStorage = (key) => {
  if (key) {
    localStorage.removeItem(key);
  }
};

export const clearLocalStorage = () => {
  localStorage.clear();
};

export const clearLocalStorageOnLogout = () => {
  Object.keys(localStorage).forEach((key) => {
    if (key != "userLocation" && key !== "welcomeModalShown") {
      localStorage.removeItem(key);
    }
  });
};

export const generateBase64AgentId = (agentId) => {
  return btoa(`gitcha-${agentId}`);
};

export const trimString = (inputString) => {
  if (inputString) {
    return inputString.trim();
  }
  return "";
};

export const checkIsNull = (inputString) => {
  if (inputString) {
    return trimString(inputString) === "";
  }
  return false;
};

export const filterArray = (array, key, value) => {
  const filteredArray = array.filter(function (co) {
    return co[key] === value;
  });
  return _.get(filteredArray[0], "text", null);
};

export const itemList = (itemArray, filterId, filterKey) => {
  if (filterId) {
    filterArray(itemArray, filterKey, filterId);
  } else {
    return itemArray;
  }
};

export const filterArrayBasedOnKey = ({
  list,
  filterKey,
  value,
  isNotEqual = false,
}) => {
  if (list) {
    const filterArray = list.filter(function (lst) {
      if (isNotEqual) {
        return lst[filterKey] !== value;
      }
      return lst[filterKey] == value;
    });
    return filterArray;
  }
  return null;
};

export const getFileType = (filename) => {
  return filename.split(".").pop();
};

export const loadPropertTypeImage = (typeId) => {
  switch (typeId) {
    case IS_LAND:
      return (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M7.42675 1.49023C7.26679 1.4837 7.10893 1.52852 6.97627 1.61813C6.84361 1.70774 6.7431 1.83745 6.68944 1.98828L6.37792 2.82715C6.24825 2.8112 6.13374 2.75 5.99999 2.75C5.78468 2.75 5.59554 2.83347 5.39159 2.87402L5.01464 2.05078C4.97514 1.9589 4.91768 1.87584 4.84561 1.80649C4.77355 1.73714 4.68834 1.68291 4.59501 1.64697C4.50167 1.61104 4.4021 1.59413 4.30213 1.59725C4.20217 1.60037 4.10384 1.62345 4.01292 1.66513C3.92201 1.70681 3.84035 1.76625 3.77275 1.83995C3.70514 1.91365 3.65296 2.00013 3.61927 2.0943C3.58559 2.18847 3.57107 2.28842 3.57658 2.38828C3.58209 2.48814 3.60751 2.58589 3.65135 2.67578L4.0244 3.48926C3.76049 3.69756 3.5476 3.94011 3.35839 4.21875L2.51073 3.9043C2.41789 3.86766 2.31867 3.84993 2.21888 3.85213C2.1191 3.85433 2.02076 3.87642 1.92962 3.91712C1.83849 3.95781 1.75639 4.01628 1.68814 4.0891C1.61988 4.16193 1.56685 4.24764 1.53215 4.34122C1.49745 4.4348 1.48177 4.53437 1.48604 4.63409C1.4903 4.7338 1.51443 4.83167 1.557 4.92194C1.59957 5.01222 1.65973 5.09309 1.73395 5.15982C1.80817 5.22654 1.89497 5.27779 1.98925 5.31055L2.82714 5.62109C2.81111 5.75107 2.74999 5.86591 2.74999 6C2.74999 6.21545 2.81124 6.41304 2.85155 6.61719L2.05077 6.98437C1.96117 7.0254 1.88053 7.08367 1.81346 7.15587C1.74639 7.22806 1.69419 7.31276 1.65986 7.40513C1.62552 7.4975 1.60972 7.59572 1.61335 7.6942C1.61698 7.79268 1.63997 7.88947 1.68101 7.97906C1.72205 8.06865 1.78034 8.14928 1.85255 8.21634C1.92476 8.2834 2.00947 8.33558 2.10184 8.3699C2.19421 8.40421 2.29244 8.42 2.39092 8.41635C2.48939 8.4127 2.58619 8.38969 2.67577 8.34863L3.45018 7.99414C3.68394 8.2925 3.9706 8.54516 4.291 8.74902C3.26853 9.59851 2.64695 10.3762 2.35057 10.7666C2.35057 10.7669 2.35057 10.7673 2.35057 10.7676C2.11767 11.0745 1.99999 11.4462 1.99999 11.8184V17.2275V19.75C1.99999 20.7075 2.79251 21.5 3.74999 21.5H20.25C21.2075 21.5 22 20.7075 22 19.75V7.32519C22 6.47229 21.3718 5.72736 20.5234 5.5957C20.5231 5.5957 20.5228 5.5957 20.5224 5.5957C19.5735 5.44959 18.2018 5.25 15.25 5.25C12.8693 5.25 10.8919 5.59852 9.2412 6.11621C9.2426 6.07712 9.24999 6.03935 9.24999 6C9.24999 5.78469 9.16652 5.59555 9.12596 5.3916L9.94823 5.01465C10.0401 4.97516 10.1232 4.91769 10.1925 4.84562C10.2619 4.77356 10.3161 4.68835 10.352 4.59502C10.388 4.50169 10.4049 4.40211 10.4018 4.30214C10.3986 4.20218 10.3756 4.10385 10.3339 4.01294C10.2922 3.92202 10.2328 3.84036 10.1591 3.77276C10.0854 3.70516 9.99888 3.65298 9.90471 3.61929C9.81054 3.5856 9.71059 3.57108 9.61073 3.57659C9.51087 3.5821 9.41312 3.60752 9.32323 3.65137L8.51073 4.02441C8.30232 3.76036 8.06006 3.54669 7.78124 3.35742L8.09569 2.51172C8.139 2.40041 8.15511 2.28037 8.14267 2.16158C8.13023 2.04279 8.0896 1.92869 8.02417 1.82878C7.95874 1.72886 7.87039 1.64601 7.76647 1.58712C7.66256 1.52824 7.54609 1.49502 7.42675 1.49023ZM5.99999 4.25C6.21873 4.25 6.42213 4.30153 6.61425 4.37305H6.61522C6.64274 4.38248 6.67078 4.39031 6.69921 4.39648C7.08903 4.56457 7.39466 4.87353 7.57421 5.25684C7.58735 5.28878 7.60269 5.31978 7.6201 5.34961C7.69981 5.55092 7.74999 5.76841 7.74999 6C7.74999 6.18502 7.72165 6.36016 7.66991 6.52441C7.65164 6.58242 7.64049 6.64243 7.63671 6.70312C6.88938 7.02857 6.24015 7.38737 5.66307 7.75391C5.60442 7.71736 5.54099 7.6891 5.4746 7.66992C4.76682 7.44772 4.24999 6.791 4.24999 6C4.24999 5.78025 4.30089 5.57566 4.37303 5.38281C4.37336 5.38216 4.37369 5.38151 4.37401 5.38086C4.38297 5.3546 4.39047 5.32787 4.39647 5.30078C4.56514 4.90961 4.87555 4.60306 5.26073 4.42383C5.29026 4.41136 5.31897 4.397 5.34667 4.38086C5.54873 4.30042 5.76733 4.25 5.99999 4.25ZM15.25 6.75C15.4761 6.75 15.6306 6.75762 15.8369 6.75977C15.2974 7.14142 14.6944 7.61752 14.0439 8.23926C11.86 10.3268 9.15361 13.931 6.88768 20H3.74999C3.60246 20 3.49999 19.8975 3.49999 19.75V17.4648C7.63714 10.5263 14.1142 6.90527 14.1142 6.90527C14.1766 6.87122 14.2338 6.82847 14.2842 6.77832C14.6015 6.76547 14.9148 6.75 15.25 6.75ZM18.665 6.87695C18.9013 6.89812 19.1129 6.92086 19.3086 6.94434C18.985 7.36353 18.5783 7.96468 18.1006 8.84863C17.0146 10.8582 15.5884 14.2799 14.1074 20H8.49315C10.6454 14.4384 13.1321 11.1862 15.081 9.32324C17.1177 7.3764 18.4785 6.96387 18.4785 6.96387C18.5444 6.9436 18.6071 6.91436 18.665 6.87695ZM11.0137 7.16602C8.99226 8.64932 6.02936 11.184 3.49999 14.7334V11.8184C3.49999 11.7595 3.51779 11.7109 3.54589 11.6738H3.54491C4.21449 10.7918 6.16923 8.18303 11.0137 7.16602ZM20.5 7.85352V19.75C20.5 19.8975 20.3975 20 20.25 20H15.6601C17.082 14.6014 18.4338 11.3863 19.4199 9.56152C19.867 8.73427 20.2321 8.19973 20.5 7.85352Z"
            fill="#4A4C4F"
          />
        </svg>
      );
    case IS_HOUSE:
      return (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M12 2.50781C11.4257 2.50781 10.8515 2.69464 10.377 3.06836H10.376L4.42969 7.75488C3.52791 8.46557 3 9.55149 3 10.7002V19.7441C3 20.7016 3.79252 21.4941 4.75 21.4941H19.25C20.2075 21.4941 21 20.7016 21 19.7441V10.7002C21 9.55149 20.4721 8.46557 19.5703 7.75488L19.5 7.69824V3.75C19.5 3.55109 19.421 3.36034 19.2803 3.21969C19.1397 3.07904 18.9489 3.00002 18.75 3H16.25C16.0511 3.00002 15.8603 3.07904 15.7197 3.21969C15.579 3.36034 15.5 3.55109 15.5 3.75V4.54688L13.623 3.06836C13.1485 2.69464 12.5743 2.50781 12 2.50781ZM12 4.00391C12.2449 4.00391 12.4899 4.08529 12.6953 4.24707L15.7861 6.68164C15.8967 6.76865 16.0296 6.82279 16.1695 6.83789C16.3094 6.85298 16.4507 6.82842 16.5773 6.767C16.7039 6.70558 16.8107 6.60979 16.8854 6.49056C16.9602 6.37134 16.9999 6.23349 17 6.09277V4.5H18V8.0625C18.0001 8.1759 18.0259 8.2878 18.0754 8.3898C18.125 8.4918 18.197 8.58123 18.2861 8.65137L18.6426 8.93262C19.1848 9.35993 19.5 10.0099 19.5 10.7002V19.7441C19.5 19.8917 19.3975 19.9941 19.25 19.9941H4.75C4.60248 19.9941 4.5 19.8917 4.5 19.7441V10.7002C4.5 10.0099 4.8152 9.35993 5.35742 8.93262L11.3047 4.24707C11.5101 4.08529 11.7551 4.00391 12 4.00391ZM7.25 11.9941C7.05109 11.9942 6.86034 12.0732 6.71969 12.2138C6.57904 12.3545 6.50002 12.5452 6.5 12.7441V16.7441C6.50002 16.943 6.57904 17.1338 6.71969 17.2744C6.86034 17.4151 7.05109 17.4941 7.25 17.4941H10.25C10.4489 17.4941 10.6397 17.4151 10.7803 17.2744C10.921 17.1338 11 16.943 11 16.7441V12.7441C11 12.5452 10.921 12.3545 10.7803 12.2138C10.6397 12.0732 10.4489 11.9942 10.25 11.9941H7.25ZM13.75 11.9941C13.5511 11.9942 13.3603 12.0732 13.2197 12.2138C13.079 12.3545 13 12.5452 13 12.7441V16.7441C13 16.943 13.079 17.1338 13.2197 17.2744C13.3603 17.4151 13.5511 17.4941 13.75 17.4941H16.75C16.9489 17.4941 17.1397 17.4151 17.2803 17.2744C17.421 17.1338 17.5 16.943 17.5 16.7441V12.7441C17.5 12.5452 17.421 12.3545 17.2803 12.2138C17.1397 12.0732 16.9489 11.9942 16.75 11.9941H13.75ZM8 13.4941H9.5V15.9941H8V13.4941ZM14.5 13.4941H16V15.9941H14.5V13.4941Z"
            fill="#009CDA"
          />
        </svg>
      );
    case IS_MANUFACTURE:
      return (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M6 3C5.87292 2.99995 5.74792 3.03219 5.63672 3.09368C5.52552 3.15517 5.43177 3.24391 5.36425 3.35156L1.61425 9.35156C1.54309 9.46509 1.50364 9.59562 1.5 9.72956C1.49636 9.8635 1.52867 9.99597 1.59356 10.1132C1.65846 10.2304 1.75357 10.3281 1.86901 10.3962C1.98445 10.4642 2.116 10.5 2.25 10.5H9.75H21.9375C22.0715 10.5 22.203 10.4642 22.3185 10.3962C22.4339 10.3281 22.529 10.2304 22.5939 10.1132C22.6588 9.99597 22.6911 9.8635 22.6875 9.72956C22.6839 9.59562 22.6444 9.46509 22.5732 9.35156L18.8232 3.35156C18.7557 3.24391 18.662 3.15517 18.5508 3.09368C18.4396 3.03219 18.3146 2.99995 18.1875 3H6.00879H6ZM7.35351 4.5H17.7715L20.584 9H10.166L7.35351 4.5ZM6 5.16504L8.39648 9H3.60351L6 5.16504ZM2.25 12C2.05109 12 1.86034 12.079 1.71969 12.2197C1.57904 12.3603 1.50002 12.5511 1.5 12.75V20.25C1.50002 20.4489 1.57904 20.6397 1.71969 20.7803C1.86034 20.921 2.05109 21 2.25 21H9.75C9.9489 21 10.1397 20.921 10.2803 20.7803C10.421 20.6397 10.5 20.4489 10.5 20.25V12.75C10.5 12.5511 10.421 12.3603 10.2803 12.2197C10.1397 12.079 9.9489 12 9.75 12H2.25ZM12.75 12C12.5511 12 12.3603 12.079 12.2197 12.2197C12.079 12.3603 12 12.5511 12 12.75V20.25C12 20.4489 12.079 20.6397 12.2197 20.7803C12.3603 20.921 12.5511 21 12.75 21H21.75C21.9489 21 22.1397 20.921 22.2803 20.7803C22.421 20.6397 22.5 20.4489 22.5 20.25V12.75C22.5 12.5511 22.421 12.3603 22.2803 12.2197C22.1397 12.079 21.9489 12 21.75 12H12.75ZM3 13.5H9V19.5H3V13.5ZM13.5 13.5H21V19.5H13.5V13.5Z"
            fill="#4A4C4F"
          />
        </svg>
      );
    case IS_TOWNHOME:
      return (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M7.3726 2.00007C7.17277 2.00352 6.98203 2.09108 6.84074 2.24421L2.22536 7.24418C2.0811 7.40044 2.00004 7.61237 2 7.83337V21.1666C2.00002 21.3876 2.08107 21.5996 2.22532 21.7559C2.36958 21.9121 2.56522 21.9999 2.76923 22H21.2308C21.4348 21.9999 21.6304 21.9121 21.7747 21.7559C21.9189 21.5996 22 21.3876 22 21.1666V7.83337C22 7.61237 21.9189 7.40044 21.7746 7.24418L17.1593 2.24421C17.015 2.08799 16.8194 2.00023 16.6154 2.00023C16.4114 2.00023 16.2158 2.08799 16.0715 2.24421L12 6.65499L7.92849 2.24421C7.85564 2.16526 7.7689 2.10296 7.67341 2.06103C7.57792 2.01909 7.47562 1.99836 7.3726 2.00007ZM7.38462 4.01178L11.2308 8.17842V20.3333H3.53846V8.17842L7.38462 4.01178ZM16.6154 4.01178L20.4615 8.17842V20.3333H12.7692V8.17842L16.6154 4.01178ZM5.07692 10.3334V12H6.61538V10.3334H5.07692ZM8.15385 10.3334V12H9.69231V10.3334H8.15385ZM14.3077 10.3334V12H15.8462V10.3334H14.3077ZM17.3846 10.3334V12H18.9231V10.3334H17.3846ZM5.07692 13.6667V15.3333H6.61538V13.6667H5.07692ZM8.15385 13.6667V15.3333H9.69231V13.6667H8.15385ZM14.3077 13.6667V15.3333H15.8462V13.6667H14.3077ZM17.3846 13.6667V15.3333H18.9231V13.6667H17.3846ZM5.07692 17V18.6667H6.61538V17H5.07692ZM8.15385 17V18.6667H9.69231V17H8.15385ZM14.3077 17V18.6667H15.8462V17H14.3077ZM17.3846 17V18.6667H18.9231V17H17.3846Z"
            fill="#4A4C4F"
          />
        </svg>
      );
    case IS_APARTMENT_CONDO:
      return (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M6.74414 1.5C6.54625 1.50157 6.357 1.58127 6.21762 1.72175C6.07823 1.86224 6.00001 2.05211 6 2.25V10.5H4.5V9H3V10.5H2.625C2.0122 10.5 1.5 11.0122 1.5 11.625V21H9H17.25H22.5V8.625C22.5 8.0122 21.9878 7.5 21.375 7.5H18V5.40821C17.9999 5.24718 17.9481 5.09045 17.852 4.96118C17.756 4.83192 17.6209 4.73699 17.4668 4.69043L16.5 4.40039V1.5H15V3.94922L13.5 3.49805V1.5H12V3.04688L6.9668 1.53223C6.89462 1.51035 6.81956 1.49949 6.74414 1.5ZM7.5 3.25781L16.5 5.96778V19.5H13.5V17.8682C13.9382 17.7132 14.3176 17.4264 14.5862 17.0472C14.8548 16.6679 14.9993 16.2148 15 15.75C15 15.1533 14.7629 14.581 14.341 14.159C13.919 13.7371 13.3467 13.5 12.75 13.5C12.1533 13.5 11.581 13.7371 11.159 14.159C10.7371 14.581 10.5 15.1533 10.5 15.75C10.5007 16.2148 10.6452 16.6679 10.9138 17.0472C11.1824 17.4264 11.5618 17.7132 12 17.8682V19.5H9V11.625C9 11.0122 8.4878 10.5 7.875 10.5H7.5V3.25781ZM9 7.5V9H15V7.5H9ZM18 9H21V19.5H18V18H19.5V16.5H18V15H19.5V13.5H18V12H19.5V10.5H18V9ZM10.5 10.5V12H15V10.5H10.5ZM3 12H7.5V19.5H3V12ZM4.5 13.5V15H6V13.5H4.5ZM4.5 16.5V18H6V16.5H4.5Z"
            fill="#4A4C4F"
          />
        </svg>
      );
    default:
      return (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M12 2.50781C11.4257 2.50781 10.8515 2.69464 10.377 3.06836H10.376L4.42969 7.75488C3.52791 8.46557 3 9.55149 3 10.7002V19.7441C3 20.7016 3.79252 21.4941 4.75 21.4941H19.25C20.2075 21.4941 21 20.7016 21 19.7441V10.7002C21 9.55149 20.4721 8.46557 19.5703 7.75488L19.5 7.69824V3.75C19.5 3.55109 19.421 3.36034 19.2803 3.21969C19.1397 3.07904 18.9489 3.00002 18.75 3H16.25C16.0511 3.00002 15.8603 3.07904 15.7197 3.21969C15.579 3.36034 15.5 3.55109 15.5 3.75V4.54688L13.623 3.06836C13.1485 2.69464 12.5743 2.50781 12 2.50781ZM12 4.00391C12.2449 4.00391 12.4899 4.08529 12.6953 4.24707L15.7861 6.68164C15.8967 6.76865 16.0296 6.82279 16.1695 6.83789C16.3094 6.85298 16.4507 6.82842 16.5773 6.767C16.7039 6.70558 16.8107 6.60979 16.8854 6.49056C16.9602 6.37134 16.9999 6.23349 17 6.09277V4.5H18V8.0625C18.0001 8.1759 18.0259 8.2878 18.0754 8.3898C18.125 8.4918 18.197 8.58123 18.2861 8.65137L18.6426 8.93262C19.1848 9.35993 19.5 10.0099 19.5 10.7002V19.7441C19.5 19.8917 19.3975 19.9941 19.25 19.9941H4.75C4.60248 19.9941 4.5 19.8917 4.5 19.7441V10.7002C4.5 10.0099 4.8152 9.35993 5.35742 8.93262L11.3047 4.24707C11.5101 4.08529 11.7551 4.00391 12 4.00391ZM7.25 11.9941C7.05109 11.9942 6.86034 12.0732 6.71969 12.2138C6.57904 12.3545 6.50002 12.5452 6.5 12.7441V16.7441C6.50002 16.943 6.57904 17.1338 6.71969 17.2744C6.86034 17.4151 7.05109 17.4941 7.25 17.4941H10.25C10.4489 17.4941 10.6397 17.4151 10.7803 17.2744C10.921 17.1338 11 16.943 11 16.7441V12.7441C11 12.5452 10.921 12.3545 10.7803 12.2138C10.6397 12.0732 10.4489 11.9942 10.25 11.9941H7.25ZM13.75 11.9941C13.5511 11.9942 13.3603 12.0732 13.2197 12.2138C13.079 12.3545 13 12.5452 13 12.7441V16.7441C13 16.943 13.079 17.1338 13.2197 17.2744C13.3603 17.4151 13.5511 17.4941 13.75 17.4941H16.75C16.9489 17.4941 17.1397 17.4151 17.2803 17.2744C17.421 17.1338 17.5 16.943 17.5 16.7441V12.7441C17.5 12.5452 17.421 12.3545 17.2803 12.2138C17.1397 12.0732 16.9489 11.9942 16.75 11.9941H13.75ZM8 13.4941H9.5V15.9941H8V13.4941ZM14.5 13.4941H16V15.9941H14.5V13.4941Z"
            fill="#009CDA"
          />
        </svg>
      );
  }
};

export function toTitleCase(str) {
  return str?.replace(/\w\S*/g, function (txt) {
    return txt?.charAt(0).toUpperCase() + txt?.substr(1);
  });
}

export const loadPhotos = (photos, className) => {
  const photosCount = photos.length;
  var dom_content = [];
  if (photos.length === 0) {
    return (
      <div className={className || "inventory-banner position-relative mt-30"}>
        <div className="banner-row">
          {" "}
          <div className="banner-column-full w-100 h-204">
            <div className="full-col-img-wrap h-100 placeholder-wrap-bg brdr-8">
              <img
                className="brdr-8 mw-100 placeholder-img-style"
                src={noImage}
                alt={noImage}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
  if (photosCount > 0) {
    if (photosCount === 1) {
      dom_content.push(
        <div className="banner-column-full h-204">
          <div className="full-col-img-wrap h-204">
            <img
              className="brdr-8 w-100 col-img-style"
              src={_.get(photos[0], "image", "")}
              alt={_.get(photos[0], "image", "")}
            />
          </div>
        </div>,
      );
    }
    if (photosCount === 2) {
      dom_content.push(
        <>
          <div className="banner-column-half h-204">
            <div className="half-col-img-wrap h-204">
              <img
                className="brdr-top-left-8 brdr-btm-left-8 brdr-t-r-8 no-brdr-b-l-0 col-img-style"
                src={_.get(photos[0], "image", "")}
              />
            </div>
          </div>
          <div className="banner-column-half h-204">
            <div className="half-col-img-wrap-right h-204">
              <img
                className="brdr-top-right-8 brdr-btm-right-8 no-brdr-t-r-0 brdr-b-r-8 brdr-b-l-8 col-img-style"
                src={_.get(photos[1], "image", "")}
              />
            </div>
          </div>
        </>,
      );
    }

    if (photosCount === 3) {
      dom_content.push(
        <>
          <div className="banner-column-twothird h-204">
            <div className="half-col-img-wrap h-204">
              <img
                className="brdr-top-left-8 brdr-btm-left-8 brdr-t-r-8 no-brdr-b-l-0 col-img-style"
                src={_.get(photos[0], "image", "")}
              />
            </div>
          </div>
          <div className="banner-column-onethird h-204">
            <div className="quarter-col-img-wrap-top h-50-percent rh-204">
              <img
                className="brdr-top-right-8 no-brdr-t-r-0 col-img-style"
                src={_.get(photos[1], "image", "")}
              />
            </div>
            <div className="quarter-col-img-wrap-btm h-50-percent rh-204">
              <img
                className="brdr-btm-right-8 brdr-b-l-8 col-img-style"
                src={_.get(photos[2], "image", "")}
              />
            </div>
          </div>
        </>,
      );
    }
    if (photosCount === 4) {
      dom_content.push(
        <>
          <div className="banner-column-half h-204">
            <div className="half-col-img-wrap h-204">
              <img
                src={_.get(photos[0], "image", "")}
                className="brdr-top-left-8 brdr-btm-left-8 brdr-t-r-8 no-brdr-b-l-0 col-img-style"
              />
            </div>
          </div>

          <div className="banner-column-30percent h-204">
            <div className="percent30-col-img-wrap h-204">
              <img
                src={_.get(photos[1], "image", "")}
                className="col-img-style"
              />
            </div>
          </div>
          <div className="banner-column-20percent h-204">
            <div className="quarter-col-img-wrap-top h-50-percent rh-204">
              <img
                src={_.get(photos[2], "image", "")}
                className="brdr-top-right-8 no-brdr-t-r-0 col-img-style"
              />
            </div>

            <div className="quarter-col-img-wrap-btm h-50-percent rh-204">
              <img
                src={_.get(photos[3], "image", "")}
                className="brdr-btm-right-8 brdr-b-l-8 col-img-style"
              />
            </div>
          </div>
        </>,
      );
    }
    if (photosCount >= 5) {
      dom_content.push(
        <>
          <div className="banner-column-half h-204">
            <div className="half-col-img-wrap h-204">
              <img
                className="brdr-top-left-8 brdr-btm-left-8 brdr-t-r-8 no-brdr-b-l-0 col-img-style"
                src={_.get(photos[0], "image", "")}
              />
            </div>
          </div>

          <div className="banner-column-quarter h-204">
            <div className="quarter-col-img-wrap-top h-50-percent rh-204">
              <img
                className="col-img-style"
                src={_.get(photos[1], "image", "")}
              />
            </div>
            <div className="quarter-col-img-wrap-btm h-50-percent rh-204">
              <img
                className="col-img-style"
                src={_.get(photos[2], "image", "")}
              />
            </div>
          </div>

          <div className="banner-column-quarter h-204">
            <div className="quarter-col-img-wrap-top h-50-percent rh-204">
              <img
                className="brdr-top-right-8 no-brdr-t-r-0 col-img-style"
                src={_.get(photos[3], "image", "")}
              />
            </div>
            <div className="quarter-col-img-wrap-btm h-50-percent rh-204 col-pad-btm">
              <img
                className="brdr-btm-right-8 brdr-b-l-8 col-img-style"
                src={_.get(photos[4], "image", "")}
              />
            </div>
          </div>
        </>,
      );
    }
    return (
      <div className={className || "inventory-banner position-relative mt-30"}>
        {photosCount > 5 ? (
          <div className="upload-cover-btn upload-cover-btn-pos">
            +{photosCount - 5}
          </div>
        ) : (
          ""
        )}

        <div className="banner-row">{dom_content}</div>
      </div>
    );
  } else {
    return "";
  }
};
export const getUserId = () => {
  const user = getLocalStorage(USER_INFO_KEY);
  return _.get(user, "userInfo.userId", null);
};

export const getUserType = () => {
  const user = getLocalStorage(USER_INFO_KEY);
  return _.get(user, "userInfo.userType", null);
};

export const getUserName = () => {
  const user = getLocalStorage(USER_INFO_KEY);
  return _.get(user, "userInfo.name", null);
};

export const formatResponse = (value) => {
  if (value) {
    value = JSON.parse(JSON.stringify(value));
    value.forEach((obj) => renameKey(obj, "Id", "value"));
    value.forEach((obj) => renameKey(obj, "Text", "label"));
    return value;
  }
  return null;
};

/**
 * To rename the key names to new name
 */
export const renameKey = (obj, oldKey, newKey) => {
  obj[newKey] = obj[oldKey];
  delete obj[oldKey];
};

/**
 * To combine the key names to new key
 */
export const combineKey = (obj, oldKey1, oldKey2, newKey) => {
  obj[newKey] = obj[oldKey1] + " " + obj[oldKey2];
};

/* To get the card icon */
export const getCardIcon = (brand) => {
  switch (brand) {
    case "Visa":
      return VisaIcon;

    case "MasterCard":
      return MasterIcon;
    case "American Express":
      return AmexIcon;
    default:
      return null;
  }
};

/* To get the card icon */
export const getCardIconForIntroduction = (brand) => {
  switch (brand) {
    case "Visa":
      return IntroductionVisaIcon;
    case "MasterCard":
      return IntroductionMasterIcon;
    case "American Express":
      return AmexIcon;
    default:
      return null;
  }
};

export const getInitials = (name) => {
  let initials = null;
  let backgroundColor = null;
  let firstLetter = null;
  const nameSplit = name.split(" ");
  const nameLength = nameSplit.length;

  if (nameLength > 1) {
    const firstChars = name
      .split(" ")
      .map((word) => word[0])
      .join("");
    // initials = firstChars.substring(0, 2)
    initials = firstChars.substring(0, 2); // considered only one character bcz group name has no space
    firstLetter = firstChars.substring(0, 1); // considered only one character bcz group name has no space
  } else if (nameLength === 1) {
    initials = nameSplit[0].substring(0, 2);
    firstLetter = nameSplit[0].substring(0, 1);
  } else return;

  firstLetter = firstLetter.toUpperCase();

  if (
    firstLetter == "A" ||
    firstLetter == "F" ||
    firstLetter == "K" ||
    firstLetter == "P" ||
    firstLetter == "U"
  )
    backgroundColor = "profile-bg-green";
  else if (
    firstLetter == "B" ||
    firstLetter == "G" ||
    firstLetter == "L" ||
    firstLetter == "Q" ||
    firstLetter == "V"
  )
    backgroundColor = "profile-bg-orange";
  else if (
    firstLetter == "C" ||
    firstLetter == "H" ||
    firstLetter == "M" ||
    firstLetter == "R" ||
    firstLetter == "W"
  )
    backgroundColor = "profile-bg-meroon";
  else if (
    firstLetter == "D" ||
    firstLetter == "I" ||
    firstLetter == "N" ||
    firstLetter == "S" ||
    firstLetter == "X"
  )
    backgroundColor = "profile-bg-paleblue";
  else if (
    firstLetter == "E" ||
    firstLetter == "J" ||
    firstLetter == "O" ||
    firstLetter == "T" ||
    firstLetter == "Y"
  )
    backgroundColor = "profile-bg-turquoise";
  else backgroundColor = "profile-bg-green";

  let returnData = {
    backgroundColor: backgroundColor,
    initials: initials.toUpperCase(),
  };

  return returnData;
};

export const isDateInThePast = (month, year) => {
  const today = new Date();
  let currentMonth = String(today.getMonth() + 1).padStart(2, "0");
  let currentYear = today.getFullYear();
  let newMonth = String(month).padStart(2, "0");
  if (year > currentYear) {
    return false;
  } else if (year == currentYear) {
    if (newMonth >= currentMonth) {
      return false;
    } else {
      return true;
    }
  } else {
    return true;
  }
};

export const sortItems = (order, property) => (a, b) => {
  const itemA = _.get(a, property);
  const itemB = _.get(b, property);
  if (order === "asc") {
    return itemA < itemB ? -1 : 1;
  } else {
    return itemA < itemB ? 1 : -1;
  }
};

export const timeAgo = (date) => {
  var ms = new Date().getTime() - new Date(date).getTime();
  var seconds = Math.floor(ms / 1000);
  var minutes = Math.floor(seconds / 60);
  var hours = Math.floor(minutes / 60);
  var days = Math.floor(hours / 24);
  var months = Math.floor(days / 30);
  var years = Math.floor(months / 12);
  let test = "";
  if (ms <= 0) {
    return "Just now";
  }
  if (seconds < 60) {
    return seconds + " seconds Ago";
  }
  if (minutes < 60) {
    return minutes + " minutes Ago";
  }
  if (hours < 24) {
    return hours + " hours Ago";
  }
  if (days < 30) {
    return days + " days Ago";
  }
  if (months < 12) {
    return months + " months Ago";
  } else {
    return years + " years Ago";
  }
};

export const getPeriod = (num) => {
  if (num === 3) {
    return "year";
  } else if (num === 2) {
    return "month";
  } else return "free";
};

export const getPeriod_Mobile = (num) => {
  if (num === 3) {
    return "Annual";
  } else if (num === 2) {
    return "Monthly";
  } else return "Free";
};

export const getPlanName_Mobile = (userTypeId, period) => {
  if (period === 3) {
    return "Premium";
  } else if (period === 2) {
    return "Premium";
  } else {
    if (userTypeId === 1) return "Free";
    else return "Member";
  }
};

export const getpropertyName = (jsonObject) => {
  const propertyName = _.get(jsonObject, "PropertyTypeText", "");
  const subPropertyName = _.get(jsonObject, "Sub_PropertyTypeText", "")
    ? _.get(jsonObject, "Sub_PropertyTypeText", "")
    : _.get(jsonObject, "SubPropertyTypeText", "");
  if (subPropertyName !== "null" && subPropertyName) {
    return subPropertyName;
  }
  return propertyName;
};

export const checkNotNull = (item) => {
  if ((item && item !== "null") || item !== "undefined") {
    return true;
  } else {
    return false;
  }
};

export const handleLogOut = () => {
  clearLocalStorage();
  window.location.reload(false);
};

export const removeMultipleLocalStorageItems = (keysToRemove) => {
  keysToRemove.forEach((k) => localStorage.removeItem(k));
};

export const removeDecimalZeros = (value) => {
  if (value) {
    return value * 1;
  }
  return null;
};

export const removeDecimalZerosFromTextField = (value) => {
  if (value) {
    return value.toString().replace(/\.00$/, "");
  }
  return null;
};

export const createS3Folder = async (isWantAd = false) => {
  return await getS3FolderName({ isWantAd: isWantAd })
    .then((response) => {
      const result = _.get(response, "result", null);
      if (response.errorCode === 0 && result) {
        const folderName = _.get(result, "folderName", "");
        return folderName;
      }
    })
    .catch((err) => {
      console.log("Error", err);
    });
};

export const createS3FolderForBuyersListingService = async (
  client_Want_ad_Id,
  isWantAd = false,
) => {
  if (client_Want_ad_Id) {
    return await getBuyerListUniqueFolderName({
      client_Want_ad_Id: client_Want_ad_Id,
      isWantAd: isWantAd,
    })
      .then((response) => {
        const result = _.get(response, "result", null);
        if (response.errorCode === 0 && result) {
          const folderName = _.get(result, "folderName", "");
          return folderName;
        }
      })
      .catch((err) => {
        console.log("Error", err);
      });
  }
};

export const createStaticMapImage = async (
  lat,
  lng,
  mapZoom = DEFAULT_MAP_ZOOM,
  isFromWantAd,
) => {
  const mapImgResolution = "800x400";
  const requestPayload = {
    latitude: lat,
    longitude: lng,
    zoom: mapZoom,
    size: mapImgResolution,
    format: "jpeg",
    isFromWantAd: isFromWantAd || false,
  };
  return await getMapStaticImage(requestPayload)
    .then((response) => {
      return response.blob();
    })
    .catch((err) => {
      console.log("Error", err);
    });
};

export const createPreSignedUrl = async (
  isWantAd = false,
  s3FolderName = "",
  isVideo = false,
) => {
  const baseFolderPath = isWantAd ? "WantAdMapImages/" : "/InventoryImages/";
  const details = getLocalStorage(isWantAd ? WANT_AD_KEY : INVENTORY_KEY);
  const s3Folder = s3FolderName
    ? s3FolderName
    : _.get(details, "s3ImageFolder", null);
  let randomFourDigits = Math.floor(1000 + Math.random() * 9000); // Generate a random 4-digit number
  let fileName =
    s3Folder +
    (isWantAd ? "_wantAdMapImg" : "_inventoryMapImg") +
    `_${randomFourDigits}.jpeg`;

  if (isVideo && isWantAd) {
    fileName = s3Folder + "_wantAdVideo.mp4";
  }
  const imgPath = baseFolderPath + s3Folder + "/" + fileName;
  const reqPayload = !s3Folder
    ? {
        folder: baseFolderPath + s3Folder + "/",
        keys: [{ id: 1, path: imgPath }],
      }
    : { keys: [{ id: 1, path: imgPath }] };
  const response = await getPreSignedUrls(reqPayload);
  return response;
};
export const createPreSignedUrlForVideo = async (
  isWantAd = false,
  s3FolderName = "",
) => {
  const baseFolderPath = isWantAd ? "WantAdVideos/" : "InventoryVideos/";
  const details = getLocalStorage(isWantAd ? WANT_AD_KEY : INVENTORY_KEY);
  const s3Folder = s3FolderName
    ? s3FolderName
    : _.get(details, "s3ImageFolder", null);
  // Construct the filename for the video
  const fileName = `${s3Folder}${
    isWantAd ? "_wantAdVideo.mp4" : "_inventoryVideo.mp4"
  }`;
  const videoPath = `${baseFolderPath}${s3Folder}/${Math.floor(
    1000 + Math.random() * 9000,
  )}/${fileName}`;

  // Prepare payload for pre-signed URL request
  const reqPayload = !s3Folder
    ? {
        folder: `${baseFolderPath}${s3Folder}/`,
        keys: [{ id: 1, path: videoPath }],
      }
    : { keys: [{ id: 1, path: videoPath }] };

  // Fetch pre-signed URLs
  const response = await getPreSignedUrls(reqPayload);
  return response?.result?.[0]?.presignedUrl;
};

export const yearValidation = (year) => {
  var regExpression = /^[0-9]+$/;
  if (year.length === 4) {
    if (regExpression.test(year)) {
      var current_year = new Date().getFullYear();
      if (year < 1900 || year > current_year) {
        return false;
      }
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
};

export const getLotSizeLists = async () => {
  return await getLotSizeList()
    .then((response) => {
      if (response.errorCode === 0 && _.get(response, "result", null)) {
        const list = _.get(response, "result", null);
        let newList = [];
        list.map((lst) => {
          const value = _.get(lst, "Lot_Value");
          const text = _.get(lst, "LotSz_TexT", "");
          newList.push({ value: value, label: text });
        });
        return newList;
      }
    })
    .catch((err) => {
      return [];
    });
};

export const removeFixedDecimalPart = ({ value, decimalPoint }) => {
  if (value && decimalPoint) {
    return value.toFixed(decimalPoint);
  }
};

export const isValidDate = ({ dateString, format }) => {
  let dateRegex;
  if (format === DATE_FORMAT_MM_DD_YYYY) {
    dateRegex = /^(0[1-9]|1[0-2])[/.-](0[1-9]|[12][0-9]|3[01])[/.-](\d{4})$/;
  }
  if (!dateRegex.test(dateString)) {
    return false; // Invalid format
  }
  var selectedDate = new Date(dateString);
  var currentDate = new Date();
  if (selectedDate < currentDate) {
    return false; // Invalid format
  }
  return true;
};

export const getLocalStorageValue = ({
  localStorageKey,
  searchKey,
  defaultValue,
}) => {
  if (localStorageKey && searchKey) {
    return _.get(
      getLocalStorage(localStorageKey),
      searchKey,
      defaultValue || null,
    );
  }
  return null;
};

export const getPriceText = (adType) => {
  if (adType === "LTR") {
    return "Price(monthly)";
  } else if (adType === "STR") {
    return "Price(nightly)";
  } else {
    return "Price";
  }
};

export const getMeters = (miles) => {
  if (miles) {
    return miles * 1609.344;
  }
  return null;
};

export const getCookie = (cname) => {
  let name = cname + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(";");
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
};

export const arraySplice = (list, index) => {
  if (list?.length) {
    return list.slice(0, index);
  }
  return [];
};

export const sendEmailContactSupport = (message) => {
  const email = "support@gitcha.com";
  const subject = "";
  const emailBody = "Hi Gitcha Support Team,";
  window.location.href =
    "mailto:" + email + "?subject=" + subject + "&body=" + emailBody;
};

export const sendEmailSales = (message) => {
  const email = "sales@gitcha.com";
  const subject = "";
  const emailBody = "Hi Gitcha Sales Team,";
  window.location.href =
    "mailto:" + email + "?subject=" + subject + "&body=" + emailBody;
};

export const sendEmailShareUrl = (email, clientName, link) => {
  const subject = "";
  const emailBody =
    "Hi " +
    clientName +
    ",\n Please click the link to add the want ad details" +
    link;
  window.location.href =
    "mailto:" + email + "?subject=" + subject + "&body=" + emailBody;
};

export const reSizeImage = ({ file, width, height, fileType }) =>
  new Promise((resolve) => {
    Resizer.imageFileResizer(
      file,
      width,
      height,
      fileType,
      100,
      0,
      (uri) => {
        resolve(uri);
      },
      "blob",
    );
  });

export const getPlanPeriodText = (period) => {
  if (period === 3) {
    return "annual";
  } else if (period === 2) {
    return "monthly";
  } else {
    return "";
  }
};

export const checkTutorialDisplayStatus = (page) => {
  // 1= Home page left side menu tutorial
  // 2 = Introduction dropdown tutorial in header dropdown;
  // 3 = Introduction details popup tutorial
  // 4 = Agent dashboard tutorial
  // 5= Wantadd display tutorial
  // 6= Wantadd add  tutorial
  // 7= Inventory(property) add  tutorial
  // 8= Inventory drafts tutorial
  // 9= WantAd Drafts tutorial
  // 10=Pro Dashboard Tutorial
  let tutorialDisplayedPages = getLocalStorage("tutorialDisplayedPages");
  let showNotification =
    tutorialDisplayedPages && tutorialDisplayedPages.includes(page)
      ? false
      : true;
  return showNotification;
};

export const saveTutorialStatusToLocal = (page) => {
  // 1= Home page left side menu tutorial
  // 2 = Introduction dropdown tutorial in header dropdown;
  // 3 = Introduction details popup tutorial
  // 4 = Agent dashboard tutorial
  // 5= Wantadd display tutorial
  // 6= Wantadd add  tutorial
  // 7= Inventory(property) add  tutorial
  let tutorialDisplayedPages = getLocalStorage("tutorialDisplayedPages");
  tutorialDisplayedPages = tutorialDisplayedPages ? tutorialDisplayedPages : [];
  if (!tutorialDisplayedPages.includes(page)) {
    tutorialDisplayedPages.push(page);
    setLocalStorage("tutorialDisplayedPages", tutorialDisplayedPages);
  }
  return true;
};

export const generateFileName = () => {
  let result = "";
  const list = "abcedefghijklmnopqrstuvwxyz123456789";
  for (let i = 0; i < 7; i++) {
    var rnd = Math.floor(Math.random() * list.length);
    result = result + list.charAt(rnd);
  }
  return result;
};

export const handleMobileUserLogin = () => {
  const userDetails = getLocalStorage(USER_INFO_KEY);
  const userType = _.get(userDetails, "userInfo.userType", null);
  const agentTitle = _.get(userDetails, "userInfo.agentTitle", null);
  const isVerified = _.get(userDetails, "userInfo.userIsVerified", null);
  const planStatus = _.get(userDetails, "userInfo.planStatus", null);
  const userStatus = _.get(userDetails, "userInfo.userStatus", null);
  let userLoginStatus = { isValidLogin: false, userType: userType };
  if (userDetails) {
    if (userType) {
      if (isVerified && planStatus && userStatus) {
        userLoginStatus.isValidLogin = true;
      } else {
        if (convertToNumber(userType) === USER_TYPE_AGENT) {
          if (!agentTitle) {
            userLoginStatus.noAgentTitle = true;
          } else if (!planStatus) {
            userLoginStatus.noAgentPlanSelected = true;
          } else if (!userStatus) {
            userLoginStatus.noAgentUserDetails = true;
          }
        } else {
          if (!planStatus) {
            userLoginStatus.noMemberPlanSelected = true;
          } else if (!userStatus) {
            userLoginStatus.noMemberUserDetails = true;
          }
        }
      }
    } else {
      userLoginStatus.noUserType = true;
    }
  }
  return userLoginStatus;
};
export const getAdTypeText = (adType) => {
  if (adType === BUY) {
    return DISPLAY_TEXT_BUY;
  } else if (adType === LONG_RENT) {
    return DISPLAY_TEXT_LTR;
  } else if (adType === SHORT_RENT) {
    return DISPLAY_TEXT_STR;
  }
};

export const displayAd = (adType) => {
  if (adType === BUY) {
    return DISPLAY_BUY;
  } else if (adType === LONG_RENT) {
    return DISPLAY_LTR;
  } else if (adType === SHORT_RENT) {
    return DISPLAT_STR;
  }
};

export const displayAdTimeLine = (adType) => {
  if (adType === BUY) {
    return DISPLAY_BUY;
  } else if (adType === LONG_RENT) {
    return DISPLAY_LTR_TIMELINE;
  } else if (adType === SHORT_RENT) {
    return DISPLAT_STR;
  }
};

export const displayPropertyType = (adType) => {
  if (adType === BUY) {
    return DISPLAY_BUY;
  } else if (adType === LONG_RENT) {
    return DISPLAY_LTR;
  } else if (adType === SHORT_RENT) {
    return DISPLAY_STR_PPTY_TYPE;
  }
};

export const decryption = (value) => {
  const bytes = base64.decode(value);
  const decodedId = utf8.decode(bytes);
  if (decodedId) {
    const decodedData = decodedId.split("-");
    return decodedData.length > 0 ? decodedData[1] : null;
  }
  return null;
};

export const getCurrentPath = () => {
  const location = useLocation();
  const pathName = _.get(location, "pathname", null)?.toLowerCase();
  return pathName;
};

export const checkArrayisEqual = (a, b) => {
  // check if the lengths are equal
  if (a?.length !== b?.length) {
    return false;
  }

  // iterate over first array
  for (let i of a) {
    // if current element in the first array is not present in the second array
    if (b?.indexOf(i) === -1) {
      return false;
    }
  }

  return true;
};

export const getClientLogo = (firstName, lastName) => {
  let clientName = lastName + " " + firstName;
  if (clientName) {
    clientName = clientName.replace(/-/g, "").match(/\b(\w)/g);
  }
  return clientName;
};

export const getPropertyPurpose = (
  is_Seller,
  is_ShortTerm_Renter,
  is_LongTerm_Renter,
) => {
  const proprtyPurpose = [];
  if (is_Seller) proprtyPurpose.push(INVENTORY_PURPOSE.Seller);
  if (is_ShortTerm_Renter)
    proprtyPurpose.push(INVENTORY_PURPOSE.Short_Term_Rent);
  if (is_LongTerm_Renter) proprtyPurpose.push(INVENTORY_PURPOSE.Long_Term_Rent);

  return proprtyPurpose;
};

export const decodeParam = (param) => {
  let decodedParam;
  let paramDecoded;
  try {
    const bytes = base64.decode(param);
    decodedParam = utf8.decode(bytes);
    if (decodedParam) {
      let decodedParamData = decodedParam.split("-");
      paramDecoded = decodedParamData.length > 0 ? decodedParamData[1] : null;
    }
  } catch {}

  return paramDecoded;
};

export const classesBasedOnScroll = (scrollDirection) => {
  let mainWrapperClass =
    "gitcha-main-wrapper my-client-wrap view-client-wrap pb-90 windowscroll-fix";
  let contentWrapperClass =
    "content-wrapper content-wrapper-h-90-percent windowscroll-fix";
  if (scrollDirection === SCROLL_DIRECTION_DOWN) {
    mainWrapperClass =
      "gitcha-main-wrapper my-client-wrap view-client-wrap pad-btm-0 windowscroll-fix";
    contentWrapperClass = "content-wrapper h-100 windowscroll-fix";
  }
  return {
    mainWrapperClass: mainWrapperClass,
    contentWrapperClass: contentWrapperClass,
  };
};

export const setBodyBackgroundWhite = () => {
  document.body.style.background = "white";
};

export const setBodyBackgroundGrey = () => {
  document.body.style.background = "#f9f9fa";
};

export const setBodyBackgroundDarkGrey = () => {
  document.body.style.background = "#e6eaf2";
};

export function formatPhoneNumber(value) {
  if (!value) return value;

  const phoneNumber = value.replace(/[^\d]/g, "");

  const phoneNumberLength = phoneNumber.length;

  if (phoneNumberLength < 4) return phoneNumber;

  if (phoneNumberLength < 7) {
    return `${phoneNumber.slice(0, 3)}-${phoneNumber.slice(3)}`;
  }
  return `${phoneNumber.slice(0, 3)}-${phoneNumber.slice(
    3,
    6,
  )}-${phoneNumber.slice(6, 10)}`;
}

export function formatDisplayPhoneNumber(value) {
  if (!value) return value;

  const phoneNumber = value.replace(/[^\d]/g, "");

  const phoneNumberLength = phoneNumber.length;

  if (phoneNumberLength < 4) return phoneNumber;

  if (phoneNumberLength < 7) {
    return `${phoneNumber.slice(0, 3)}-${phoneNumber.slice(3)}`;
  }
  return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(
    3,
    6,
  )}-${phoneNumber.slice(6, 10)}`;
}

export const setHtmlClassName = (className) => {
  document.getElementById("scroll-chain").classList.add(className);
};

export const removeHtmlClassName = (className) => {
  document.getElementById("scroll-chain").classList.remove(className);
};

export const getDisplayTextForClientFilledWantAds = (
  IsFilledByClient,
  IsReadyToReview,
) => {
  if (IsFilledByClient) {
    if (IsReadyToReview) {
      return "(Ready to Review)";
    } else {
      return "(Pending with Client)";
    }
  } else {
    return "";
  }
};

export const loadCompensationText = (compenstaionType, compensationValue) => {
  let value = "";
  if (compenstaionType == 1) {
    value = "Buyer’s Agent Compensation: " + compensationValue + "%";
  } else if (compenstaionType == 2) {
    value =
      "Buyer’s Agent Compensation: $" +
      thousandSeperatedValue(removeDecimalZeros(compensationValue));
  } else if (compenstaionType == 3) {
    value =
      "Buyer’s Agent Compensation: Not requesting compensation from the seller";
  } else if (compenstaionType == 4) {
    value = "Buyer’s Agent Compensation: Negotiable";
  }
  return value;
};

// Function to compare two JSON arrays
export const areArraysEqual = (array1, array2) => {
  // Check if arrays have different lengths
  if (array1?.length !== array2?.length) {
    return false;
  }

  // Sort arrays to ensure order doesn't affect comparison
  const sortedArray1 = array1?.slice().sort();
  const sortedArray2 = array2?.slice().sort();

  // Convert arrays to strings and compare
  const string1 = JSON.stringify(sortedArray1);
  const string2 = JSON.stringify(sortedArray2);

  return string1 === string2;
};

export const locationDisplay = (formValues, isFromSharePopUp = false) => {
  const zipCodeValue = [];
  if (formValues?.zipCode) {
    formValues?.zipCode.map((zip) => {
      zipCodeValue.push(zip?.zipCode);
    });
  }
  const location = formValues?.location ?? formValues?.Location;
  const city = formValues?.city ?? formValues?.City;
  const state = formValues?.state ?? formValues?.State;
  const mapRadius = formValues?.mapRadius ?? formValues?.Radius;

  let text = "";
  if (zipCodeValue?.length > 0) {
    text = isFromSharePopUp
      ? "Within ZIP(s) code " + zipCodeValue.join(", ")
      : "Within ZIP(s) code " + zipCodeValue.join(", ");
  } else if (location) {
    text = isFromSharePopUp
      ? "in " + city + ", " + state
      : "Within " + mapRadius + " mi of " + city + ", " + state;
  }
  return text;
};
export const handleKeyDownToPreventMinusSign = (event) => {
  // Prevent the "-" character from being entered
  if (event.key === "-") {
    event.preventDefault();
  }
  const inputValue = parseFloat(event.target.value + event.key);
  // If the entered value is less than 0.25 and it's not a backspace key, prevent default behavior
  if (inputValue < 0.25 && event.key !== "Backspace") {
    event.preventDefault();
  }
};

export const handleKeyDownToPreventCharacters = (event) => {
  // Prevent the "-" character from being entered
  if (
    !/^\d$/.test(event.key) && // Check if the key pressed is a digit
    // event.key !== '.' && // Check if the key pressed is a period
    event.key !== "Backspace" && // Allow backspace
    event.key !== "Delete" && // Allow delete
    event.key !== "ArrowLeft" && // Allow arrow left
    event.key !== "ArrowRight" && // Allow arrow right
    event.key !== "Tab" && // Allow tab
    event.key !== "Home" && // Allow home
    event.key !== "End" && // Allow end
    event.key !== "Enter" && // Allow enter
    event.key !== "Escape" // Allow escape
  ) {
    event.preventDefault();
  }
};

export const locationDisplayInListing = (formValues) => {
  const zipCodeValue = formValues?.zipCode;
  // const zipCodeValue =  [97402,97403,97405]
  const location = formValues?.location ?? formValues?.Location;
  const city = formValues?.city ?? formValues?.City;
  const state = formValues?.state ?? formValues?.State;
  const mapRadius = formValues?.mapRadius ?? formValues?.Radius;

  let text = "";
  if (zipCodeValue?.length > 0) {
    text = truncate("Within ZIP(s) code " + zipCodeValue.join(", "), 40);
  } else if (location) {
    text = mapRadius + " mi of " + city + ", " + state;
  } else {
    text = "No location added";
  }
  return text;
};

/**
 * function to get title text in home screen
 */
export const getTitleText = (
  userLocation,
  isGitchaGenieFilter,
  isCityInPreLaunch,
  getLocationText,
) => {
  if (isCityInPreLaunch) {
    return <h2>Coming soon!</h2>;
  } else if (
    userLocation &&
    !userLocation?.isFromAvailableCities &&
    !isGitchaGenieFilter
  ) {
    return (
      <h2>
        {userLocation?.city && userLocation?.state
          ? userLocation?.city + ", " + userLocation?.state + " isn't available"
          : userLocation?.formatted_address + " isn't available"}
      </h2>
    );
  } else if (userLocation && !isGitchaGenieFilter)
    return <h2>{getLocationText()}</h2>;
  else if (isGitchaGenieFilter) {
    return <h2>{getLocationText()}</h2>;
  } else return "";
};

/**
 * function to get title text in home screen in mobile view
 */
export const getTitleTextMobile = (
  userLocation,
  isGitchaGenieFilter,
  isCityInPreLaunch,
  getLocationText,
) => {
  if (isCityInPreLaunch) {
    return "Coming soon!";
  } else if (
    userLocation &&
    !userLocation?.isFromAvailableCities &&
    !isGitchaGenieFilter
  ) {
    return userLocation?.city && userLocation?.state
      ? userLocation?.city + ", " + userLocation?.state + " isn't available"
      : userLocation?.formatted_address + " isn't available";
  } else if (userLocation && !isGitchaGenieFilter) return getLocationText();
  else if (isGitchaGenieFilter) {
    return getLocationText();
  } else return "";
};

export const calculateTimeLeft = (startDate) => {
  if (startDate) {
    const introAcceptedDate = moment.utc(startDate); // Replace with your UTC date string

    // Calculate expiration date
    const introExpirationDate = moment
      .utc(introAcceptedDate)
      .add(INTRODUCTION_EXPIRATION_TIME, "hours");

    // Get current UTC time
    const currentUtcTime = moment.utc();

    // Calculate time left until expiration
    const timeLeft = moment.duration(introExpirationDate.diff(currentUtcTime));

    // Access time left in hours and minutes
    const hoursLeft = timeLeft.asHours();
    const minutesLeft = timeLeft.asMinutes();
    const secondsLeft = timeLeft.asSeconds();

    return {
      hours: Math.floor(hoursLeft),
      minutes: Math.floor(minutesLeft),
      seconds: Math.floor(secondsLeft),
    };
  } else {
    return {
      hours: 0,
      minutes: 0,
      seconds: 0,
    };
  }
};
export const getLocalityFromZipCode = async (addressObject) => {
  if (addressObject?.zip) {
    const reqPayload = `address=${addressObject?.zip}&components=country:US`;
    let city = null;
    return await getGeoLocation(reqPayload).then((data) => {
      const results = _.get(data, "results");
      if (results?.length > 0) {
        const firstAddressComponent = _.get(
          results[0],
          "address_components",
          "",
        );
        if (firstAddressComponent && firstAddressComponent.length > 0) {
          const locality = firstAddressComponent.filter(function (ca) {
            return ca.types?.[0] === "locality";
          });
          if (locality.length) {
            addressObject.city = _.get(locality?.[0], "long_name", "");
          }
          return addressObject;
        } else {
          return addressObject;
        }
      }
      return addressObject;
    });
  } else {
    return addressObject;
  }
};

export const clearLocationStatesExceptLatLng = (handleFormValues) => {
  handleFormValues({
    location: "",
    city: "",
    state: "",
    zip: "",
    isGitchaAvailable: null,
  });
};

export const checkPlanCanbeUpgraded = (
  currentActivePlan,
  selectedPlan,
  selectedPeriod,
) => {
  let comparePlan = { canPlanUpgrade: true };
  if (
    currentActivePlan?.PlanName == "Member" &&
    currentActivePlan?.period === 3 &&
    selectedPlan === "Investor Member" &&
    selectedPeriod === 2
  ) {
    comparePlan = { annualToMonthly: true, canPlanUpgrade: false };
  } else if (
    currentActivePlan?.PlanName == "Member" &&
    currentActivePlan?.period === 3 &&
    selectedPlan === "Pro Member" &&
    selectedPeriod === 2
  ) {
    comparePlan = { annualToMonthly: true, canPlanUpgrade: false };
  } else if (
    currentActivePlan?.PlanName == "Investor Member" &&
    currentActivePlan?.period === 3 &&
    selectedPlan === "Pro Member" &&
    selectedPeriod === 2
  ) {
    comparePlan = { annualToMonthly: true, canPlanUpgrade: false };
  } else if (currentActivePlan?.period !== 1 && selectedPlan === "Lite") {
    comparePlan = { toLightPlan: true, canPlanUpgrade: false };
  }
  return comparePlan;
};

export const getCurrentPlanText = (currentActivePlan) => {
  if (currentActivePlan?.PlanName === INVESTOR_MEMBER_PLAN) {
    return "investor";
  } else {
    return "member";
  }
};

export const getImageForShare = (adType) => {
  if (adType === "BUY") {
    return "https://gitcha-uploads.s3.amazonaws.com/Gitcha_images/WantAd-Buy-New.png";
  } else {
    return "https://gitcha-uploads.s3.amazonaws.com/Gitcha_images/WantAd-Rent.png";
  }
};

export const getCardElementOptions = (elem) => {
  const CARD_ELEMENT_OPTIONS = {
    placeholder: elem,
    iconStyle: "solid",
    hidePostalCode: true,
    style: {
      base: {
        iconColor: "rgb(240, 57, 122)",
        color: "#15181E",
        fontSize: "16px",
        fontFamily: '"Supreme-Regular", sans-serif',
        fontSmoothing: "antialiased",
        "::placeholder": {
          color: "#797E86",
        },
      },
      invalid: {
        color: "#e74c3c",
        ":focus": {
          color: "#303238",
        },
      },
    },
  };

  return CARD_ELEMENT_OPTIONS;
};
